const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#96D5EA",
    fillOpacity: 0.2,
    style: {
      fill: "#96D5EA",
      fill: "color(display-p3 0.5882 0.8353 0.9176)",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.61321C6 7.2284 6.13514 6.91094 6.40541 6.66082C6.67567 6.4107 7.02703 6.28564 7.45946 6.28564C7.88417 6.28564 8.2278 6.40877 8.49035 6.65505C8.76061 6.90902 8.89575 7.23994 8.89575 7.64784C8.89575 8.01725 8.76448 8.32508 8.50193 8.57136C8.23166 8.82533 7.87645 8.95231 7.43629 8.95231H7.42471C7 8.95231 6.65637 8.82533 6.39382 8.57136C6.13127 8.31739 6 7.998 6 7.61321ZM6.15058 17.7142V10.0028H8.72201V17.7142H6.15058ZM10.1467 17.7142H12.7181V13.4083C12.7181 13.1389 12.749 12.9311 12.8108 12.7849C12.9189 12.5233 13.083 12.302 13.3031 12.1211C13.5232 11.9403 13.7992 11.8499 14.1313 11.8499C14.9961 11.8499 15.4286 12.4309 15.4286 13.593V17.7142H18V13.2929C18 12.1538 17.7297 11.29 17.1892 10.7012C16.6486 10.1125 15.9344 9.81811 15.0463 9.81811C14.0502 9.81811 13.2741 10.2452 12.7181 11.0995V11.1226H12.7066L12.7181 11.0995V10.0028H10.1467C10.1622 10.2491 10.1699 11.0148 10.1699 12.3001C10.1699 13.5853 10.1622 15.39 10.1467 17.7142Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedIn);
export default __webpack_public_path__ + "static/media/icon-linkedIn.973f2dd8806ffaa94b97e91673a1f0da.svg";
export { ForwardRef as ReactComponent };